import { render, staticRenderFns } from "./adverse-media.html?vue&type=template&id=066672e4&scoped=true&"
import script from "./adverse-media.js?vue&type=script&lang=js&"
export * from "./adverse-media.js?vue&type=script&lang=js&"
import style0 from "./adverse-media.scss?vue&type=style&index=0&id=066672e4&prod&scoped=true&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=066672e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066672e4",
  null
  
)

export default component.exports